import { render, staticRenderFns } from "./ReportAppCustomerService.vue?vue&type=template&id=f5c8bcfa&scoped=true&"
import script from "./ReportAppCustomerService.vue?vue&type=script&lang=js&"
export * from "./ReportAppCustomerService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c8bcfa",
  null
  
)

export default component.exports